













import './KisweTimeSelector.scss'
import { defineComponent, computed } from '@vue/composition-api'
import { TimePicker } from 'element-ui'
import { TimePickerOptions } from 'element-ui/types/time-picker'
import { TimeSelectOptions } from 'element-ui/types/time-select'

export default defineComponent({
  name: 'KisweTimeSelector',
  components: {
    'el-time-picker': TimePicker
  },
  props: {
    value: {
      type: Date,
      required: false,
      default: new Date()
    },
    clearable: {
      type: Boolean,
      required: false,
      default: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    placeholder: {
      type: String,
      required: false,
      default: 'Select time'
    },
    options: {
      type: Object as () => TimePickerOptions & TimeSelectOptions,
      required: false
    },
    label: {
      type: String,
      required: false,
      default: null
    }
  },
  emits: {
    input (_newTime: Date) { return true }
  },
  setup (props, { emit }) {
    return {
      time: computed({
        get () { return props.value },
        set (newTime: Date) { emit('input', newTime) }
      })
    }
  }
})
